import { useEffect, useState } from "react";
import { getAllDesignRequests } from "../../services/axios";
import { DesignRow } from "./design-row";

type PRODUCT_VARIANTS = {
  color_name: string;
  color_hex: string;
};

type DESIGN_REQUEST = {
  id: string;
  pk: string;
  status: string;
  campaign: string;
  design_file_url: string;
  design_file_name: string;
  design_file_id: string;
  product_template_name: string;
  product_template_url: string;
  product_template_brand: string;
  product_template_model: string;
  product_template_sku: string;
  configured: false;
  configured_variants: PRODUCT_VARIANTS[];
  configured_layers: string[];
  configured_design_area: string;
  configured_athletes: string[];
  configured_organizations: string[];
  configured_data_url: string;
  request_priority: 0;
  request_job_url: string;
  created_at: string;
  updated_at: string;
};

export const Designs = () => {
  const [designs, setDesigns] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const getDesigns = await getAllDesignRequests();
      console.log(getDesigns);
      setDesigns(getDesigns);
    };
    fetch();
  }, []);

  return (
    <div className="m-8">
      <div className="flex justify-between border-b">
        <div className="p-2 font-bold text-2xl">Designs</div>
      </div>
      <table className="table-fixed w-full border-collapse border border-deeppurple text-sm">
        <thead>
          <tr>
            <th className="border border-deeppurple">timestamp</th>
            <th className="border border-deeppurple">status</th>
            <th className="border border-deeppurple">id</th>
            <th className="border border-deeppurple">campaign</th>
            <th className="border border-deeppurple">name</th>
            <th className="border border-deeppurple">sku</th>
            <th className="border border-deeppurple">design areas</th>
            <th className="border border-deeppurple">job url</th>
            <th className="border border-deeppurple">view</th>
            <th className="border border-deeppurple">restart</th>
            <th className="border border-deeppurple">delete</th>
          </tr>
        </thead>
        <tbody>
          {designs?.map((design: DESIGN_REQUEST, index: number) => {
            return <DesignRow key={index} {...design} />;
          })}
        </tbody>
      </table>
    </div>
  );
};
